import {debug_log} from "./debug";

export function network_error() {
    const reload_ok = window.confirm(
        "ネットワークエラーが発生しました。\n" +
        "自動保存を正常に実行するために、インターネットに接続していることを確認してください。\n" +
        "\n" +
        "ページを再読み込みします。"
    );

    if (reload_ok) {
        window.location.reload();
    }
}

/**
 * 特定の DOM で Copy Event を発火させる仕掛け
 *
 * @param element
 */
export function fireCopyEvent(element: Node) {
    selectElement(element);
    document.execCommand('copy');
}

export function selectElement(element: Node) {
    const selection = window.getSelection();
    if (!selection) {
        debug_log('failed copy event')
        return;
    }

    if (0 < selection.rangeCount) {
        selection.removeAllRanges();
    }
    const range = document.createRange();
    range.selectNode(element);
    range.collapse(true);
    selection.addRange(range);
}
